module.exports = __webpack_public_path__ + "img/film.d58b4912.png";